// extracted by mini-css-extract-plugin
export default {"avatar":"avatar_avatar__THRHU","contactIcon":"avatar_contactIcon__hS1lR"};